import { render } from "./TargetsList.vue?vue&type=template&id=3ddc7bb7&scoped=true&ts=true"
import script from "./TargetsList.vue?vue&type=script&lang=ts"
export * from "./TargetsList.vue?vue&type=script&lang=ts"

import "./TargetsList.vue?vue&type=style&index=0&id=3ddc7bb7&lang=scss&scoped=true"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddc7bb7"]])

export default __exports__